import React from "react";

import { ReactComponent as Illustration } from "../../../../assets/images/home/housing.svg";

import Button from "../../../../components/Habitacional/core/Button/Button";
import ContentSection from "../../../../components/Habitacional/ContentSection";

import * as S from "./HousingSection.Style";

const HousingSection = () => {
  return (
    <ContentSection
      title="Seguro Habitacional"
      description="Consulte as coberturas e assistências do seu seguro, saiba como funciona o pedido de indenização, 
            baixe as condições gerais e consulte os resultados dos sorteios."
      illustration={<Illustration />}
      reverse
    >
      <S.HousingSectionContainer>
        <Button
          variant="primary"
          onClick={() => window.open("/paravoce/habitacional", "_blank")}
        >
          Saber mais
        </Button>
        <Button
          variant="muted-primary"
          onClick={() => {
            window.location.href = "/paravoce/habitacional/acionar_sinistro";
          }}
        >
          Acionar o seguro
        </Button>
      </S.HousingSectionContainer>
    </ContentSection>
  );
};

export default HousingSection;
